const jobs = [
    {
        id: 1,
        company: "Bachelor's",
        mainCompany: 'Ahmedabad University',
        url: 'https://ahduni.edu.in/',
        location: 'Gujarat, India',
        position: 'Information And Communication Technology',
        duration: 'Jul 2017 - May 2021',
        bullets: [
            "Object Oriented Programming",
            "Computer Organisation",
            "Database Management Systems",
            "Operating Systems",
            "Computer Networks",
            "Machine Learning",
            "Artificial Intelligence",
            "High Performance Computing"
        ]        
    },
    {
        id: 2,
        company: "Master's",
        mainCompany: 'Arizona State University',
        url: 'https://www.asu.edu/',
        location: 'Arizona, United States',
        position: 'Computer Science',
        duration: 'Jan 2024 - Dec 2025',
        bullets: [
            "Foundation Of Algorithms",
            "Software Security",
            "Cloud Computing",
            "Data Processing at Scale",
            "Engineering Blockchain Apps",
            "Data Mining"
        ]
        
    }
]

export default jobs